import MenusOrder from "@/views/admin/menusorder/MenusOrder";

export default {
  path: "menus/order-cartas",
  name: "MenusOrder",
  component: MenusOrder,
  props: true,
  meta: {
    requiresAuth: true
  }
};
